import { Dialog, type DialogProps } from "@cmsgov/design-system-12";
import type { FC } from "react";

export type { DialogProps } from "@cmsgov/design-system-12";

/**
 * Simple wrapper around CMSDS Dialog that only renders `children` when open
 */
export const MctDialog: FC<DialogProps> = ({ children, isOpen, ...props }) => (
  <Dialog isOpen={isOpen} {...props}>
    {isOpen && children}
  </Dialog>
);
